<div class="w-full">
  <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
    <div class="flex items-center">
      <h6 mat-dialog-title class="font-semibold primary-font">{{'edit.due.date.label' | translate}}</h6>
    </div>
    <div class="flex items-center mr-1">
      <span mat-dialog-close class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </span>
    </div>
  </div>
  <div class="flex flex-col zuper-dialog-body">
    <div>
      <form [formGroup]="updateDueDateForm" class="cancelForm h-full overflow-y-none" autocomplete="off">
        <div class="w-full mb-4">
          <div class="mr-4">
              <div *ngIf="data?.clearSchedule">
                <label for="reason" class="block text-base font-medium mb-2 text-gray-700 required">{{'due.date.text' | translate}}</label>
              </div>
              <input 
                  [matDatepicker]="picker" readonly
                  type="text" 
                  name="dueDate" 
                  id="dueDate" 
                  [min]="minDate"
                  [datePickerFormat]="utilityService?.dateFormat"
                  class="mt-1 block w-full rounded-md border border-gray-300 bg-white shadow-sm px-3 py-3 text-base cursor-pointer focus:border-indigo-500"
                  placeholder="{{'due.date.placeholder' | translate}}"
                  formControlName="due_date"
                  (click)="picker.open()"
                  [ngClass]="{'ng-touched ng-invalid' : formSubmitted && updateDueDateForm?.controls?.due_date?.invalid}"
              >
              <p class="text-red-500 text-base mt-1" *ngIf="formSubmitted && updateDueDateForm?.controls?.due_date?.touched && updateDueDateForm?.controls?.due_date?.invalid && !data?.clearSchedule">
                {{ 'due.date.required.error.message' | translate }}
              </p>
              <p class="text-red-500 text-base mt-1" *ngIf="formSubmitted && updateDueDateForm?.controls?.due_date?.touched && updateDueDateForm?.controls?.due_date?.invalid && data?.clearSchedule">
                {{ 'text.job.update_due_date_and_clear_schedule.message' | translate }}
              </p>
              <mat-datepicker #picker></mat-datepicker>
          </div>
       </div>
       <p class="font-medium text-base mt-2 text-red-600" *ngIf="jobDetails?.route?.route_uid && data?.clearSchedule">{{'dispatchBoard.scheduler.dialog.clear_schedule.note' | translate}} ' {{jobDetails?.route?.route_name}} '</p>
        <div class="grid grid-cols-2" *ngIf="jobDetails?.scheduled_start_time && !data?.clearSchedule">
          <div class="w-full flex items-center space-x-2">
            <input
                type="checkbox" (ngModelChange)="updateDueDateForm.markAllAsTouched()"
                id="update" [ngModelOptions]="{standalone: true}" [(ngModel)]="clearSchedule"/>
              <label for="update" class="block text-base flex items-center mt-3 font-medium mb-2 text-gray-700 cursor-pointer" >{{'clear.schedule.date.text' | translate}}</label>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
    
    <div class="flex justify-around space-x-4 bg-gray-50">
        <button type="button" mat-stroked-button mat-dialog-close class="px-6 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm btn-small text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">{{'cancel.text' | translate}}</button>
        <button (click)="submit()" class="min-w-24 px-6 btn-small items-center py-2 border b-1 btn-small text-base shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary">
          <span *ngIf="updateDueDateAndClearSchedule">{{'updateandclearSchedule' | translate}}</span>
          <span *ngIf="!updateDueDateAndClearSchedule">{{'update' | translate}}</span>
        </button>
    </div>
  </div>
</div> 